import styles from './index.module.css';

export default function UpdateBanner() {
    return <div className={styles.updateBanner}>Update available. Refresh page to view new content.</div>;
}
